import { useTranslation } from "react-i18next";
import EstadoBadge from "./EstadoBadge";
import EstadoVacio from "./EstadoVacio";
import "../../css/dashboardIA.css";

// Umbrales del semáforo de días en cola — DA-3 (spec.md §7), en UN SOLO lugar del código porque el comité
// puede cambiar la meta. En plazo <= 10 · Por vencer 11-15 · Atrasado 16-20 · Crítico > 20.
export const SEMAFORO_UMBRAL = { enPlazo: 10, porVencer: 15, atrasado: 20 };

export const calcularSemaforo = (dias) => {
  const valor = Number(dias) || 0;
  if (valor <= SEMAFORO_UMBRAL.enPlazo) return "EN_PLAZO";
  if (valor <= SEMAFORO_UMBRAL.porVencer) return "POR_VENCER";
  if (valor <= SEMAFORO_UMBRAL.atrasado) return "ATRASADO";
  return "CRITICO";
};

// RF-22: el semáforo usa los dos énfasis del sistema — Crítico en alto énfasis (interrumpe la lectura),
// el resto en bajo énfasis (Status.pdf, skill cloudprojects-branding §4).
const SEMAFORO_CONFIG = {
  EN_PLAZO: { rol: "ok", emphasis: "bajo", icon: "fa-check-circle" },
  POR_VENCER: { rol: "warn", emphasis: "bajo", icon: "fa-hourglass-half" },
  ATRASADO: { rol: "alert", emphasis: "bajo", icon: "fa-clock" },
  CRITICO: { rol: "alert", emphasis: "alto", icon: "fa-fire" },
};

// Bloque 6 — Mesa de decisión (RF-21/RF-22/RF-23). El código navega al detalle de la iniciativa
// (`IniciativaDetalleModal`, spec 008 RF-42): es la ÚNICA navegación de todo el tablero.
const AgendaTable = ({ filas, onVerDetalle }) => {
  const [t] = useTranslation("dashboardIA");

  if (!filas || filas.length === 0) {
    return (
      <EstadoVacio
        variante="tarjeta"
        icon="fa-calendar-check"
        titulo={t("dashboardIA_agenda_vacio_titulo")}
        descripcion={t("dashboardIA_agenda_vacio_desc")}
      />
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-sm dia-agenda mb-0">
        <thead>
          <tr>
            <th>{t("dashboardIA_agenda_col_codigo")}</th>
            <th>{t("dashboardIA_agenda_col_nombre")}</th>
            <th>{t("dashboardIA_agenda_col_clubhouse")}</th>
            <th>{t("dashboardIA_agenda_col_tipo")}</th>
            <th>{t("dashboardIA_agenda_col_tier")}</th>
            <th>{t("dashboardIA_agenda_col_dias")}</th>
            <th>{t("dashboardIA_agenda_col_semaforo")}</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((fila) => {
            const nivel = calcularSemaforo(fila.DiasEnCola);
            const config = SEMAFORO_CONFIG[nivel];
            return (
              <tr key={fila.IdIniciativa}>
                <td>
                  <button
                    type="button"
                    className="dia-agenda__link"
                    onClick={() => onVerDetalle(fila.IdIniciativa)}
                  >
                    {fila.Codigo}
                  </button>
                </td>
                <td>{fila.Nombre}</td>
                <td>{fila.Clubhouse}</td>
                <td>{fila.TipoIA}</td>
                <td>{fila.Tier}</td>
                <td>{fila.DiasEnCola}</td>
                <td>
                  <EstadoBadge
                    rol={config.rol}
                    emphasis={config.emphasis}
                    icon={config.icon}
                    label={t(`dashboardIA_semaforo_${nivel}`)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AgendaTable;
